const getActivationTypeLabel = (activation_type) => activation_type === 1 ? 'User' : activation_type === 2 ? 'Automatic' : '-';
export default getActivationTypeLabel;
